import Box from '@mui/material/Box';
import type { Message } from '@openx/components-core/lib/AiChat/types.ts';
import { useCallback } from 'react';
import { AiChat } from '../../components/AiChat/AiChat.tsx';
import { CTASection } from '../../components/CTA/CTASection.tsx';
import { DealSelect } from '../../components/DealSelect/DealSelect.tsx';
import type { DealOption } from '../../components/DealSelect/utils/types.ts';
import { OpenXAgentFeedback } from '../../components/Feedback/OpenXAgentFeedback.tsx';
import { OPENX_AGENT_TOOL } from '../../components/Home/utils/consts.ts';
import { useOpenXAgentContext } from '../../context/useOpenXAgentContext.ts';
import { useMockedAgent } from './hooks/useMockedAgent.ts';
import { rootSx } from './styles.ts';

const renderFeedbackActions = (message: Message) => <OpenXAgentFeedback message={message} />;
const renderCallsToAction = () => <CTASection />;

type TargetingExplainerProps = {
  userName: string;
};

export const TargetingExplainer = ({ userName }: TargetingExplainerProps) => {
  const { activeTool, setActiveTool } = useOpenXAgentContext();
  const { isThinking, isLoading, messages, sendMessage, thinkingProcessMessages } = useMockedAgent({ userName });

  // a picked deal becomes the tool context, the same way entry points outside OpenX Agent pass it in
  const handleDealSelect = useCallback(
    (deal: DealOption) => setActiveTool({ toolId: OPENX_AGENT_TOOL.TARGETING_EXPLAINER, toolData: deal }),
    [setActiveTool]
  );

  return (
    <Box data-test="openx-agent-targeting-explainer-view" sx={rootSx}>
      <AiChat
        isThinking={isThinking}
        isLoading={isLoading}
        messages={messages}
        sendMessage={sendMessage}
        thinkingProcessMessages={thinkingProcessMessages}
        feedbackActions={renderFeedbackActions}
        callsToAction={renderCallsToAction}
        customFooter={!activeTool.toolData && <DealSelect onSelect={handleDealSelect} />}
      />
    </Box>
  );
};
